import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M20.477 15.022a9 9 0 1 0 -7.998 5.965","key":"svg-0"}],["path",{"d":"M12 7v5l3 3","key":"svg-1"}],["path",{"d":"M16 19h6","key":"svg-2"}]]

const IconClockMinus = createReactComponent('outline', 'clock-minus', 'ClockMinus', __iconNode);

export default IconClockMinus;